import { createLogic } from 'redux-logic';
import { LIFEWAY_ACCOUNTS_URL, PATH_PROFILE } from '../constants';
import { triggerModal, fetchThirdPartyIdps, fetchThirdPartyIdpsSuccess, fetchThirdPartyIdpsError, removeThirdPartyIdpConfirm, removeThirdPartyIdp, removeThirdPartyIdpSuccess, removeThirdPartyIdpError, toggleProcessedItem, toggleModal } from '../actions/AppActions';
import history from '../utils/history';
import MessageBanner from '../components/MessageBanner';

export const fetchThirdParties = createLogic({
  type: fetchThirdPartyIdps().type,
  latest: true,
  process({ httpClient }, dispatch) {
    return httpClient(dispatch)
      .get(`${LIFEWAY_ACCOUNTS_URL}/api/thirdpartyidp/list`)
      .then(resp => dispatch(fetchThirdPartyIdpsSuccess(resp.data)))
      .catch(error => dispatch(fetchThirdPartyIdpsError(error)));
  }
});

export const removeThirdPartyConfirm = createLogic({
  type: removeThirdPartyIdpConfirm().type,
  latest: true,

  processOptions: {
    dispatchMultiple: true,
  },

  process({ action }, dispatch) {
    const modalProps = {
      show: true,
      message: `Are you sure you want to unlink your ${action.payload.providerDisplayName} account from your Lifeway Account?`,
      okLabel: 'Yes',
      okDataHook: 'removeIdp.button',
      cancelLabel: 'No',
      cancelDataHook: 'removeIdp.button',
      buttonOrder: 'rtl',
      okClick: () => {
        dispatch(toggleProcessedItem (action.payload.id));
        dispatch(removeThirdPartyIdp(action.payload.id, action.payload.providerDisplayName, action.payload.subjectId));
        dispatch(toggleModal());
      },
      cancelClick: () => {
        history.push(PATH_PROFILE);
        dispatch(toggleModal());
      }
    };
    dispatch(triggerModal(modalProps));
  }
});

export const removeThirdParty = createLogic({
  type: removeThirdPartyIdp().type,
  latest: true,
  validate({ action }, allow, reject) {
    if (action?.payload?.id && action?.payload?.subjectId) {
      allow(action);
    } else {
      reject();
    }
  },
  process({ httpClient, action }, dispatch) {
    return httpClient(dispatch)
      .post(`${LIFEWAY_ACCOUNTS_URL}/api/thirdpartyidp/revoke`, action.payload)
      .then(() => dispatch(removeThirdPartyIdpSuccess(action.payload.id)))
      .catch(error => dispatch(removeThirdPartyIdpError(error)));
  }
});


export default [ fetchThirdParties, removeThirdPartyConfirm, removeThirdParty ];
